import React from 'react'
import { Radio, RadioProps } from '@mui/material'
import * as S from './styles';

interface IKOGRadioProps extends RadioProps {

}
function KOGRadio(props: IKOGRadioProps) {
  return (
    <S.ContainerRadio>
      <Radio {...props} />
    </S.ContainerRadio>
  )
}

export default KOGRadio